import { atom } from 'recoil';
import { effectConsoleLogAtomUpdates } from '../helpers/debug';

export const selectedStateAtom = atom({
  key: 'selectedStateAtom',
  default: 'CT',
  effects: [effectConsoleLogAtomUpdates],
});
